import { render, staticRenderFns } from "./ImageFooter.vue?vue&type=template&id=d6e35268&scoped=true&"
import script from "./ImageFooter.vue?vue&type=script&lang=js&"
export * from "./ImageFooter.vue?vue&type=script&lang=js&"
import style0 from "./ImageFooter.vue?vue&type=style&index=0&id=d6e35268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e35268",
  null
  
)

export default component.exports